import React, { useCallback } from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';

import {
  PaymentAccountVerification,
  type PaymentAccountVerificationSession,
} from './PaymentAccountVerification';

export type { PaymentAccountVerificationSession } from './PaymentAccountVerification';

type Props = {
  session: PaymentAccountVerificationSession;
  ledgerId: string;
  createVerificationToken: (
    ledgerId: string
  ) => Promise<PaymentAccountVerificationSession>;
  onBack: VoidFunction;
  onCompleted: VoidFunction;
};

export const PaymentAccountVerificationPanel = ({
  session,
  ledgerId,
  createVerificationToken,
  onBack,
  onCompleted,
}: Props) => {
  const renewVerificationToken = useCallback(
    () => createVerificationToken(ledgerId),
    [createVerificationToken, ledgerId]
  );
  return (
    <section
      aria-label="Verify payment account"
      className="flex flex-col gap-f4"
    >
      <div>
        <TextButton onClick={onBack}>Back</TextButton>
      </div>
      <PaymentAccountVerification
        session={session}
        createVerificationToken={renewVerificationToken}
        onCompleted={onCompleted}
      />
    </section>
  );
};
